import React, { useState } from 'react';
import { globalBuilder } from '../../archbuilder/GlobalBuilder';

export const TopBar: React.FC = () => {
  const [open, setOpen] = useState(false);

  return globalBuilder.TopBar(open, setOpen);
};
